import servicesEn from './services.en';
import servicesAr from './services.ar';

export function getServices(lang = 'en') {
  return lang === 'ar' ? servicesAr : servicesEn;
}
